import { Tag } from '../types/audience.types';
import { EVERYONE_TAG_NAME } from '../constants/audienceDefaults';

/**
 * Check if a tag is the "Everyone" tag
 */
export const isEveryoneTag = (tag: Tag): boolean => {
    return tag.name === EVERYONE_TAG_NAME;
};

/**
 * Handle "Everyone" tag logic when adding a new tag
 * Returns the updated tag list based on "Everyone" tag rules
 */
export const handleEveryoneTagLogic = (newTag: Tag, existingTags: Tag[]): Tag[] => {
    // If "Everyone" was selected, remove all other tags
    if (isEveryoneTag(newTag)) {
        return [newTag];
    }

    // If another tag was selected and "Everyone" exists, remove "Everyone"
    const hasEveryone = existingTags.some(isEveryoneTag);
    if (hasEveryone) {
        const filteredTags = existingTags.filter(t => !isEveryoneTag(t));
        return [...filteredTags, newTag];
    }

    // Normal case: just add the new tag
    return [...existingTags, newTag];
};

/**
 * Filter available tags to exclude already selected ones
 */
export const filterAvailableTags = (allTags: Tag[], selectedTags: Tag[]): Tag[] => {
    return allTags.filter(tag => !selectedTags.some(t => t.name === tag.name));
};

/**
 * Build tag list with "Everyone" tag for include mode
 */
export const buildTagListWithEveryone = (apiTags: string[], productOptions: Tag[]): Tag[] => {
    const tags: Tag[] = [{ name: EVERYONE_TAG_NAME, type: 'pseudo', data: {} }];

    // Add regular tags from API
    apiTags.forEach(tagName => {
        tags.push({ name: tagName });
    });

    // Add product tags
    tags.push(...productOptions);

    return tags;
};

/**
 * Build tag list without "Everyone" tag for exclude mode
 */
export const buildTagListWithoutEveryone = (apiTags: string[], productOptions: Tag[]): Tag[] => {
    const tags: Tag[] = [];

    // Add regular tags from API
    apiTags.forEach(tagName => {
        tags.push({ name: tagName });
    });

    // Add product tags
    tags.push(...productOptions);

    return tags;
};
